import { types } from 'mobx-state-tree';
import { ADDABLE_KEYS } from '../EditContact/consts';
import { validateEmail } from '../utils';
import { actions } from './AddContactDataActions';
const model = {
    contactKeyBeingAdded: types.maybeNull(types.string),
    keyLabel: types.maybeNull(types.string),
    inputValue: types.optional(types.string, ''),
};
const views = self => ({
    get hasInputValidationError() {
        if (self.contactKeyBeingAdded === ADDABLE_KEYS.email) {
            return self.inputValue && !validateEmail(self.inputValue);
        }
        return false;
    },
});
const AddContactDataModel = types.model(model).actions(actions).views(views);
export default AddContactDataModel;
